export default __webpack_public_path__ + "static/media/NoteBook.a4e7e125.svg";